import { withCommonMoveSetup } from './moveDecorator.js';

/**
 * Custom implementation for Odor Sleuth move
 * This move identifies the target, allowing Normal- and Fighting-type attacks to hit Ghost types.
 */
export default class OdorSleuth {
    /**
     * Custom move logic for Odor Sleuth
     * Only contains the specific behavior for this move.
     * Common setup and cleanup are handled by the decorator.
     */
    static customMoveLogic(battleStateMachine, move, attacker, defender) {
        // Custom action: Identify the target
        battleStateMachine.context.actions.push(
            battleStateMachine.ag.readText(`The ${attacker.name} identified ${defender.name}!`, {
                delay: 50,
            }),
            battleStateMachine.ag.script(() => {
                defender.identifyBy(attacker);
            })
        );
    }

    /**
     * Sets up battle actions for Odor Sleuth move
     * Wrapped with common setup and cleanup via decorator pattern
     */
    static setUpBattleActions = withCommonMoveSetup(OdorSleuth.customMoveLogic);
}
